import Card from "react-bootstrap/Card";
import { Helmet } from "react-helmet";

import List from "./List";

export function Index() {
  return (
    <>
      <Helmet title="Återförsäljare" />
      <Card className="p-4">
        <h2 className="pb-3">Återförsäljare (med avtal)</h2>
        <List />
      </Card>
    </>
  );
}
